import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from "libphonenumber-js";

const names = new Intl.DisplayNames(["fr"], { type: "region" });

export const COUNTRIES = getCountries()
  .map((code) => ({ code, name: names.of(code) || code, dial: getCountryCallingCode(code) }))
  .sort((a, b) => a.name.localeCompare(b.name, "fr"));

export const PRIORITY = ["FR", "BE", "CH", "LU", "MC", "GB", "CI", "SN", "CM", "GP", "MQ", "RE"];

export const formatPhone = (country, number) => {
  const p = parsePhoneNumberFromString(number || "", country);
  return p && p.isPossible() ? p.formatInternational() : null;
};
